<template>
        <div v-if="getPersonInfo.data">
            <tech-detail-header :page-name="pageNm"></tech-detail-header>

            <!-- 個人情報 -->
            <private-info></private-info>

            <!-- 本人確認 -->
            <identity-info :item="getPersonInfo.data.identity_info"></identity-info>
            
            <!-- 個人情報モーダル -->
            <private-info-modal ref="privateInfo"></private-info-modal>

            <!-- メッセージ -->
            <info-msg ref="msg" :lev="lev" :msg="msg" @ok="msgOkBtn"></info-msg>
        </div>
</template>

<script>
    import TechDetailHeader from 'pages/commons/header/Header'
    import PrivateInfo from './components/Private'
    import IdentityInfo from './components/Identity'
    import InfoMsg from 'pages/commons/modal/infoMsg/InfoMsg'
    import PrivateInfoModal from 'pages/commons/modal/privateInfo/PrivateInfo'
    
    import {mapGetters} from 'vuex'
    
    export default {
        components:{
            TechDetailHeader,
            PrivateInfo,
            IdentityInfo,
            PrivateInfoModal,
            InfoMsg
        },
        data () {
            return {
                lev: 0,
                msg: '',
                key: ''
            }
        },
        mounted () {
            this.loadPersonInfo()
        },
        destroyed () {
            this.$store.dispatch('resetPersonInfo')
        },
        watch: {
            getPersonInfoLoadStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startProgress')
                }
                if (status == 2) {
                    this.$store.dispatch('doneProgress')
                }
                if (status == 3) {
                    this.$store.dispatch('doneProgress')
                }
            }
        },
        computed: {
            pageNm () {
                return '個人詳細(' + this.$route.params.name + ')'
            },
            ...mapGetters(['getPersonInfo'
                ,'getPersonInfoLoadStatus'
            ])
        },
        methods: {
            loadPersonInfo () {
                this.$store.dispatch('loadPersonInfo', {
                    userId: this.$route.params.userId
                })
            },
            openPrivateInfo () {
                this.$refs.privateInfo.openThis(this.$route.params.userId)
            },
            showMsg (msg, lev=0 , key='') {
                this.msg = msg
                this.lev = lev
                this.key = key
                this.$refs.msg.openThis()
            },
            msgOkBtn () {
                if (this.key == 'ident-ok') {
                    this.$store.dispatch('identityOk', {
                        userId: this.$route.params.userId
                    })
                }
            }
        }

    }
</script>

<style lang="stylus" scoped>

</style>
